import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../types/store';

import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { Props } from './Donations';

type StateProps = Pick<
  Props,
  | 'title'
  | 'description'
  | 'goal'
  | 'amount'
  | 'donors'
  | 'username'
  | 'userUuid'
  | 'isOwner'
  | 'moduleVersion'
>;

type DispatchProps = Pick<Props, 'pushDonateModal'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  const user = getProfileOwnerUser(state);
  return {
    ...moduleData,
    description: moduleData.textContent,
    isOwner: isCurrentUserProfileOwner(state),
    username: user.username,
    userUuid: user.useridUuid,
    moduleVersion,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  pushDonateModal: (username, title) =>
    dispatch(modalActions.pushDonateModal(ownProps.moduleId, username, title)),
});

export default connect(mapStateToProps, mapDispatchToProps);
